import { render } from "./End.vue?vue&type=template&id=2813937c&scoped=true"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"

import "./End.vue?vue&type=style&index=0&id=2813937c&lang=stylus"
import "./End.vue?vue&type=style&index=1&id=2813937c&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2813937c"]])

export default __exports__